export const visit = (vm, at) => {
at({ "no-no": { "sanitizedEmail": { "imageError": "Dette bildet er for stort til \xE5 vises.", "expandEmailButtonText": "Utvid", "collapseEmailButtonText": "Skjul", "hideEmailRepliesButtonText": "Skjul trimmet innhold", "showEmailRepliesButtonText": "Se trimmet innhold" } } });
};